export const DEFAULT_INPUT_MAX_LENGTH = 200;

export const LABEL_WARNING_MESSAGE =
  'InputField: It is highly recommended to use a Label. You set "hideLabel" to true if you want to hide the label.';
